__turbopack_context__.v({
  "container": "view-module__7ITlaW__container",
  "copyright": "view-module__7ITlaW__copyright",
  "copyrightLink": "view-module__7ITlaW__copyrightLink",
  "post": "view-module__7ITlaW__post",
  "postImage": "view-module__7ITlaW__postImage",
  "postImageContainer": "view-module__7ITlaW__postImageContainer",
  "star": "view-module__7ITlaW__star",
  "titleHeading": "view-module__7ITlaW__titleHeading",
  "titleLink": "view-module__7ITlaW__titleLink",
});
